import { useEffect, useState } from "react";

import { ApiClient } from "~/api/client";
import Input from "~/components/common/input";
import PopupFormWrapperStub from "~/components/popups/popupFormWrapperStub";
import { addRoistatIdToFormData } from "~/utils";

export default function StubNotificationForm() {
  const [fields, setFields] = useState<any>([]);
  const [result, setResult] = useState<any>({});
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const masks = {
    Телефон: "+9 (999) 999 99-99",
  };

  const submit = async () => {
    setIsProcessing(true);
    try {
      let formData = {
        ...result,
        url: typeof window !== "undefined" ? window.location.pathname : "",
      };
      formData = addRoistatIdToFormData(formData, fields);
      const data = await ApiClient.formsV2.sentForm(
        "stubNotification",
        formData,
      );
      if (data?.success) {
        setSuccess("Спасибо! Мы сообщим Вам о поступлении фаркопов первыми.");
        setResult({});
      } else if (data?.message) {
        setError(data.message);
        if (data.fields) {
          setFields(data.fields);
        }
      }
    } catch (err: any) {
      setError(err.message || "Произошла ошибка при отправке формы");
    } finally {
      setIsProcessing(false);
    }
  };

  useEffect(() => {
    const loadFields = async () => {
      setLoading(true);
      try {
        const data = await ApiClient.formsV2.getFields("stubNotification");
        setFields(data?.fields || []);
      } catch (err: any) {
        setError(err.message || "Ошибка загрузки формы");
      } finally {
        setLoading(false);
      }
    };
    loadFields();
  }, []);

  return (
    <PopupFormWrapperStub
      isLoading={isLoading}
      isProcessing={isProcessing}
      onSubmit={submit}
      errorText={error}
      successText={success}
      sentText="СООБЩИТЬ МНЕ ПЕРВОМУ!"
    >
      {fields
        ?.filter(({ TYPE }: any) => TYPE !== "checkbox")
        .map(({ NAME, CODE, REQUIRED, ERROR, TYPE }: any) => (
          <Input
            key={CODE}
            label={NAME}
            required={REQUIRED}
            mask={masks[NAME as keyof typeof masks]}
            // @ts-ignore
            onChange={(value) => setResult({ ...result, [CODE]: value })}
            isError={ERROR}
            isMultiple={TYPE === "textarea"}
            value={result[CODE] || ""}
          />
        ))}
    </PopupFormWrapperStub>
  );
}
